import axios from "axios";

const API_URL = 'https://chimera-api.eulerlogistics.com/api/v1';

export const getMovies = async (language, search, actor) => {
	try {
		const response = await axios.get(`${API_URL}/movies`, {
			params: { language, search, actor },
		});
		return response?.data?.data;
	} catch (error) {
		console.error("Error fetching movies:", error);
		throw error;
	}
};

export const getVideos = async (search, filter) => {
	try {
		const response = await axios.get(`${API_URL}/spiritual`, {
			params: { search, filter },
		});
		return response?.data?.data;
	} catch (err) {
		console.log("Error fetching videos", err);
		throw err;
	}
};

export const getActors = async () => {
	try {
		const response = await axios.get(`${API_URL}/actors`);
		return response?.data?.data;
	} catch (error) {
		console.error("Error fetching actors:", error);
		throw error;
	}
};
